import { match } from 'ts-pattern';
import type { TransformedDefinitionApiResponse } from '../types/Api';
import type { CellRendererType, EagColumn } from '../types/EagColumn';
type ColumnResponseBody = TransformedDefinitionApiResponse['columns'][number];
const mapColumnTypeToCellRendererType = (column: ColumnResponseBody): CellRendererType => {
  const renderer = column.renderer as {
    type: string;
    decimalPlaces?: number;
  };
  return match<string, CellRendererType>(column.type).with('TEXT', () => renderer.type === 'METATEXT' ? 'META_TEXT' : 'PLAIN').with('CODE_LIST', () => 'PLAIN').with('ENUM', () => renderer.type === 'FLAG' ? 'FLAG' : 'PLAIN').with('MONEY', () => {
    if (renderer.type === 'MONEY_WITHOUT_DECIMAL') {
      return 'MONEY_NO_DECIMAL';
    }
    if (renderer.type === 'DECIMAL' && renderer.decimalPlaces === 0) {
      return 'MONEY_NO_DECIMAL';
    }
    return 'MONEY';
  }).with('FLOAT', () => renderer.type === 'INTEGER' || renderer.type === 'PLAIN' ? 'INTEGER' : 'MONEY').with('DATE', () => 'DATE').with('DATE_TIME', () => renderer.type === 'DATE_TIME' ? 'DATE_TIME' : 'DATE').with('ENTITY', () => renderer.type === 'LINK' ? 'LINK' : 'PLAIN').with('TAG_VALUE', () => 'TAG').with('FILE', () => renderer.type === 'PLAIN' ? 'FILE_PLAIN' : 'FILE').with('BOOLEAN', () => renderer.type === 'CHECKBOX' ? 'CHECKBOX' : 'PLAIN').with('IMAGE', () => 'THUMBNAIL').with('INTEGER', () => renderer.type === 'PLAIN' ? 'PLAIN' : 'INTEGER').with('TIME_INTERVAL', () => 'TIME_INTERVAL').otherwise(() => 'PLAIN');
};
const getRendererParams = (column: ColumnResponseBody): Record<string, unknown> => {
  const renderer = column.renderer as {
    type: string;
    decimalPlaces?: number;
  };
  return match<string, Record<string, unknown>>(column.type).with('MONEY', () => ({
    decimalPlaces: renderer.decimalPlaces ?? 2
  })).with('FLOAT', () => ({
    decimalPlaces: renderer.decimalPlaces ?? 2
  })).otherwise(() => ({}));
};
export const columnToTypeDefs = (column: ColumnResponseBody): Partial<EagColumn> => ({
  type: mapColumnTypeToCellRendererType(column),
  rendererParams: getRendererParams(column)
});